export const SET_CERTIFICATS_LOADING = "SET_CERTIFICATS_LOADING";
export const SET_CERTIFICATS_ERROR = "SET_CERTIFICATS_ERROR";

export const FETCH_CERTIFICATS_REQUEST = "FETCH_CERTIFICATS_REQUEST";
export const FETCH_CERTIFICATS_SUCCESS = "FETCH_CERTIFICATS_SUCCESS";
export const FETCH_CERTIFICATS_FAIL = "FETCH_CERTIFICATS_FAIL";

export const FETCH_CERTIFICAT_PLACEHOLDERS_REQUEST = "FETCH_CERTIFICAT_PLACEHOLDERS_REQUEST";
export const FETCH_CERTIFICAT_PLACEHOLDERS_SUCCESS = "FETCH_CERTIFICAT_PLACEHOLDERS_SUCCESS";
export const FETCH_CERTIFICAT_PLACEHOLDERS_FAIL = "FETCH_CERTIFICAT_PLACEHOLDERS_FAIL";

export const CREATE_CERTIFICAT_REQUEST = "CREATE_CERTIFICAT_REQUEST";
export const CREATE_CERTIFICAT_SUCCESS = "CREATE_CERTIFICAT_SUCCESS";
export const CREATE_CERTIFICAT_FAIL = "CREATE_CERTIFICAT_FAIL";

export const UPDATE_CERTIFICAT_REQUEST = "UPDATE_CERTIFICAT_REQUEST";
export const UPDATE_CERTIFICAT_SUCCESS = "UPDATE_CERTIFICAT_SUCCESS";
export const UPDATE_CERTIFICAT_FAIL = "UPDATE_CERTIFICAT_FAIL";

export const DELETE_CERTIFICAT_REQUEST = "DELETE_CERTIFICAT_REQUEST";
export const DELETE_CERTIFICAT_SUCCESS = "DELETE_CERTIFICAT_SUCCESS";
export const DELETE_CERTIFICAT_FAIL = "DELETE_CERTIFICAT_FAIL";

export const CREATE_CERTIFICAT_VERSION_REQUEST = "CREATE_CERTIFICAT_VERSION_REQUEST";
export const CREATE_CERTIFICAT_VERSION_SUCCESS = "CREATE_CERTIFICAT_VERSION_SUCCESS";
export const CREATE_CERTIFICAT_VERSION_FAIL = "CREATE_CERTIFICAT_VERSION_FAIL";

export const UPDATE_CERTIFICAT_ACTIVATION_REQUEST = "UPDATE_CERTIFICAT_ACTIVATION_REQUEST";
export const UPDATE_CERTIFICAT_PUBLICATION_REQUEST = "UPDATE_CERTIFICAT_PUBLICATION_REQUEST";
export const UPDATE_CERTIFICAT_ARCHIVE_REQUEST = "UPDATE_CERTIFICAT_ARCHIVE_REQUEST";
export const UPDATE_CERTIFICAT_LIFECYCLE_SUCCESS = "UPDATE_CERTIFICAT_LIFECYCLE_SUCCESS";
export const UPDATE_CERTIFICAT_LIFECYCLE_FAIL = "UPDATE_CERTIFICAT_LIFECYCLE_FAIL";

export const GENERATE_CERTIFICAT_PDF_REQUEST = "GENERATE_CERTIFICAT_PDF_REQUEST";
export const GENERATE_CERTIFICAT_PDF_SUCCESS = "GENERATE_CERTIFICAT_PDF_SUCCESS";
export const GENERATE_CERTIFICAT_PDF_FAIL = "GENERATE_CERTIFICAT_PDF_FAIL";

export const setCertificatsLoading = (value) => ({ type: SET_CERTIFICATS_LOADING, payload: value });
export const setCertificatsError = (value) => ({ type: SET_CERTIFICATS_ERROR, payload: value });

export const fetchCertificatsRequest = () => ({ type: FETCH_CERTIFICATS_REQUEST });
export const fetchCertificatsSuccess = (payload) => ({ type: FETCH_CERTIFICATS_SUCCESS, payload });
export const fetchCertificatsFail = (payload) => ({ type: FETCH_CERTIFICATS_FAIL, payload });

export const fetchCertificatPlaceholdersRequest = () => ({ type: FETCH_CERTIFICAT_PLACEHOLDERS_REQUEST });
export const fetchCertificatPlaceholdersSuccess = (payload) => ({ type: FETCH_CERTIFICAT_PLACEHOLDERS_SUCCESS, payload });
export const fetchCertificatPlaceholdersFail = (payload) => ({ type: FETCH_CERTIFICAT_PLACEHOLDERS_FAIL, payload });

export const createCertificatRequest = (payload) => ({ type: CREATE_CERTIFICAT_REQUEST, payload });
export const createCertificatSuccess = (payload) => ({ type: CREATE_CERTIFICAT_SUCCESS, payload });
export const createCertificatFail = (payload) => ({ type: CREATE_CERTIFICAT_FAIL, payload });

export const updateCertificatRequest = (id, payload) => ({ type: UPDATE_CERTIFICAT_REQUEST, payload: { id, payload } });
export const updateCertificatSuccess = (payload) => ({ type: UPDATE_CERTIFICAT_SUCCESS, payload });
export const updateCertificatFail = (payload) => ({ type: UPDATE_CERTIFICAT_FAIL, payload });

export const deleteCertificatRequest = (id) => ({ type: DELETE_CERTIFICAT_REQUEST, payload: { id } });
export const deleteCertificatSuccess = (payload) => ({ type: DELETE_CERTIFICAT_SUCCESS, payload });
export const deleteCertificatFail = (payload) => ({ type: DELETE_CERTIFICAT_FAIL, payload });

export const createCertificatVersionRequest = (id) => ({ type: CREATE_CERTIFICAT_VERSION_REQUEST, payload: { id } });
export const createCertificatVersionSuccess = (payload) => ({ type: CREATE_CERTIFICAT_VERSION_SUCCESS, payload });
export const createCertificatVersionFail = (payload) => ({ type: CREATE_CERTIFICAT_VERSION_FAIL, payload });

export const updateCertificatActivationRequest = (id, active) => ({
    type: UPDATE_CERTIFICAT_ACTIVATION_REQUEST,
    payload: { id, active },
});

export const updateCertificatPublicationRequest = (id, publicationStatus) => ({
    type: UPDATE_CERTIFICAT_PUBLICATION_REQUEST,
    payload: { id, publicationStatus },
});

export const updateCertificatArchiveRequest = (id, archived) => ({
    type: UPDATE_CERTIFICAT_ARCHIVE_REQUEST,
    payload: { id, archived },
});

export const updateCertificatLifecycleSuccess = (payload) => ({ type: UPDATE_CERTIFICAT_LIFECYCLE_SUCCESS, payload });
export const updateCertificatLifecycleFail = (payload) => ({ type: UPDATE_CERTIFICAT_LIFECYCLE_FAIL, payload });

export const generateCertificatPdfRequest = (id, payload) => ({
    type: GENERATE_CERTIFICAT_PDF_REQUEST,
    payload: { id, ...payload },
});

export const generateCertificatPdfSuccess = (payload) => ({ type: GENERATE_CERTIFICAT_PDF_SUCCESS, payload });
export const generateCertificatPdfFail = (payload) => ({ type: GENERATE_CERTIFICAT_PDF_FAIL, payload });
